import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CompleteProfileModalComponent } from './common/auth/complete-profile/complete-profile-modal';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, CompleteProfileModalComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {}
